/*=========================================================================================
  File Name: moduleDashBoard.js
  Description: DashBoard Module
  ----------------------------------------------------------------------------------------

==========================================================================================*/


import state from './moduleDashBoardState.js'
import mutations from './moduleDashBoardMutations.js'
import actions from './moduleDashBoardActions.js'
import getters from './moduleDashBoardGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
